import React, {FC} from 'react';
import styled from 'styled-components';
import {Image} from '../Image/Image';

export interface Props {
  url: string;
  description: string;
  className?: string;
}

export const ImageIcon: FC<Props> = ({url, description, className}) => {
  return (
    <StyledIconImage
      breakpoints={[]}
      ratio="1:1"
      widths={[24]}
      src={url}
      alt={description}
      className={className}
    />
  );
};

const IMG_ICON_SIZE = 12;

const StyledIconImage = styled(Image)`
  width: ${IMG_ICON_SIZE}px;
  height: ${IMG_ICON_SIZE}px;
  margin-right: 5px;
`;
